module.exports = __webpack_public_path__ + "static/media/dashvideo.9efe5fe7.mp4";